<template>
  <transition name="modal-fade">
    <section class="main-modal fixed wh100 left0 top0 flex-center z999"
             v-if="isModal"
             @mouseup="releaseClick">
        <component @click.stop
                   @close="close"
                   :is="componentName" />
    </section>
  </transition>
</template>

<script>
import NoteConflictPreview from "@/components/Note_Conflict_Preview.vue";

export default {
  name: 'main-modal',
  components: {NoteConflictPreview},
  computed: {
    componentName () {
      const component = this.$store.state.modalComponentName;
      // eslint-disable-next-line
      return () => import(`@/components/${component}`);
    },
    isModal () {
      return this.$store.state.isModal;
    },
  },
  methods: {
    releaseClick () {
      if (this.$store.state.modalComponentName === 'addNotaModal') {
        // prevent hide the nota modal when clicking outside
        return;
      }
      this.$store.state.isClickModal
        ? this.$store.commit('SET_KEY_VALUE', { key: 'isClickModal', value: false })
        : this.close()
    },
    close () {
      this.$emit('close');
      this.$store.commit('RESET_MODAL_DATA');
      this.$store.commit('SET_MODAL', { val: false, name: '' });
    }
  }
}
</script>

<style lang="less">
  .main-modal {
    background-color: rgba(0, 0, 0, .4);
  }
</style>
